import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `/${routePrefix}`,
    component: ContainerView,
    meta: { moduleName, breadcrumbKey: 'report' },
    children: [
      {
        path: '',
        name: routeNamePrefix,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "reports" */ './views/list')
          ),
        meta: {},
      },
      {
        path: 'create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "reports" */ './views/create')
          ),
        meta: {},
      },
      {
        path: 'report-history',
        name: `${routeNamePrefix}.report-history`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "reports" */ './views/report-history')
          ),
        meta: {},
      },
      {
        path: ':moduleName/:id/preview',
        name: `${routeNamePrefix}.preview`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "reports" */ './views/preview')
          ),
        meta: {},
      },
      {
        path: ':moduleName/:id',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "reports" */ './views/edit')
          ),
        meta: {},
      },
    ],
  },
]
